import { render } from "./CalendarIndicator.vue?vue&type=template&id=bbf1cd9e"
import script from "./CalendarIndicator.vue?vue&type=script&lang=js"
export * from "./CalendarIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__